import { NgModule } from "@angular/core";
import { IonicStorageModule } from "@ionic/storage-angular";
import { AuthenticationService } from "./authentication/authentication.service";
// import { Network } from '@ionic-native/network';
import { StateService } from "./state/state.service";
import { SampleService } from "./samples/sample.service";
import { AppDataService } from "./data/app-data.service";
import { RemoteDataService } from "./data/remote-data.service";
import { LocalDataService } from "./data/local-data.service";
import { AnalyticsService } from "./analytics/analytics.service";
import { AnswerService } from "./answers/answers.service";
import { AlertService } from "./alerts/alerts.service";
import { AppService } from "../app.service";
import { AchievementsService } from "./data/achievements.service";
import { PdfCertificateService } from "./data/pdf-certificate.service";
import { LoadingService } from "./loading/loading.service";
// import { PurchaseService } from "./data/purchase.service";
/**
 * Provides core service providers for the app
 */
@NgModule({
  providers: [
    StateService,
    AuthenticationService,
    AppDataService,
    RemoteDataService,
    LocalDataService,
    SampleService,
    AnalyticsService,
    AnswerService,
    AlertService,
    AppService,
    AchievementsService,
    // Network,
    PdfCertificateService,
    LoadingService,
    // PurchaseService,
  ],
  imports: [IonicStorageModule.forRoot()],
})
export class CoreModule {}
